import type { SvgIconPropsWithChildren } from '../common/SvgIcon';

import React, { createElement } from 'react';

import { SvgIcon } from '../common/SvgIcon';

function SvgX(props: SvgIconPropsWithChildren) {
  return createElement(
    SvgIcon,
    props,
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5652 3.25H20.5319L14.0505 10.6628L21.6753 20.75H15.7052L11.0291 14.6322L5.67867 20.75H2.71018L9.64264 12.8212L2.32812 3.25H8.44986L12.6766 8.84192L17.5652 3.25ZM16.524 18.9731H18.1679L7.55663 4.93359H5.79257L16.524 18.9731Z"
        fill="currentColor"
      />
    </svg>,
  );
}
export default SvgX;
